import React, { useState } from 'react'
import Chart from "react-apexcharts";
import TabelDataforissues from "./TabelDataforissues"
import alert from "./alert.png";

export default function Productionissues() {

    const state = {
        stroke: {
          lineCap: "round",
        },
        options: {
          dataLabels: {
            enabled: false,
          },
          legend: {
            fontSize: "14px",
            fontFamily: "Poppins",
            position: "bottom",
            horizontalAlign: "center",
            // labels: {
            //   show: true,
            //   name: "Total Issus",
            //   value: 263,
            // },
          },
          title: {
            text: "263",
            align: "center",
            margin: 10,
            offsetX: 0,
            offsetY: 105,
            floating: false,
            style: {
              fontSize: "18px",
              fontWeight: "bold",
              color: "#000",
            },
          },
          subtitle: {
            text: "Total Issues",
            align: "center",
            margin: 10,
            offsetX: 0,
            offsetY: 130,
            floating: false,
            style: {
              fontSize: "16px",
              fontWeight: "bold",
              color: "#000",
            },
          },
          // subtitle: {
          //   text: ,
          //   align: "center",
          //   margin: 10,
          //   offsetX: 0,
          //   offsetY: 105,
          //   floating: false,
          //   style: {
          //     fontSize: "14px",
          //     fontWeight: "bold",
          //     color: "#000",
          //   },
          // },
          labels: ["Damaged", "Faulty", "Missing"],
          colors: ["#FF0000", "#FFFF00", "#00FF00"],
    
          plotOptions: {
            pie: {
              customScale: 1,
              donut: {
                size: "83%",
                // labels: {
                //   show: true,
                //   name: "Total Issus",
                //   value: 263,
                // },
              },
            },
          },
        },
    
        series: [45, 35, 20],
      };
      const Issuestate = {
        stroke: {
          lineCap: "round",
        },
        options: {
          dataLabels: {
            enabled: false,
          },
          legend: {
            fontSize: "14px",
            fontFamily: "Poppins",
            position: "bottom",
            horizontalAlign: "center",
            // labels: {
            //   show: true,
            //   name: "Total Issus",
            //   value: 263,
            // },
          },
          title: {
            text: "26",
            align: "center",
            margin: 10,
            offsetX: 0,
            offsetY: 105,
            floating: false,
            style: {
              fontSize: "18px",
              fontWeight: "bold",
              color: "#000",
            },
          },
          subtitle: {
            text: "Total Issues",
            align: "center",
            margin: 10,
            offsetX: 0,
            offsetY: 130,
            floating: false,
            style: {
              fontSize: "16px",
              fontWeight: "bold",
              color: "#000",
            },
          },
          // subtitle: {
          //   text: ,
          //   align: "center",
          //   margin: 10,
          //   offsetX: 0,
          //   offsetY: 105,
          //   floating: false,
          //   style: {
          //     fontSize: "14px",
          //     fontWeight: "bold",
          //     color: "#000",
          //   },
          // },
          labels: ["Damaged", "Faulty", "Missing"],
          colors: ["#FF0000", "#FFFF00", "#00FF00"],
    
          plotOptions: {
            pie: {
              customScale: 1,
              donut: {
                size: "83%",
                // labels: {
                //   show: true,
                //   name: "Total Issus",
                //   value: 263,
                // },
              },
            },
          },
        },
    
        series: [45, 35, 20],
      };
  return (
    <div>
    <div class="mt-8">
        <div class=" shadow-slate-400 shadow-md bg-white rounded-2xl flex-1">
          <div className="flex flex-wrap mr-4 pt-2">
            <h3 className="text-lg font-bold mx-3">
              {" "}
              Outstanding Issues
            </h3>
           
          </div>
          <div className="flex flex-wrap pb-2">
              <Chart
                //@ts-ignore
                options={Issuestate.options}
                series={Issuestate.series}
                type="donut"
                width="360"
              />
            <div className="flex-2 md:overflow-x-auto overflow-x-auto  float-right ml-auto mr-4 -mt-4">
              <TabelDataforissues/>
            </div>
          </div>
        </div>
      </div>
    <div class="mt-8">
        <div class=" shadow-slate-400 shadow-md bg-white rounded-2xl flex-1">
          <div className="flex flex-wrap mr-4 pt-2">
            <h3 className="text-lg font-bold mx-3"> Issues Reported</h3>
           
          </div>
          <div className="flex flex-wrap pb-2">
            <div className="flex-1 flex-wrap ">
              <Chart
                // className="sm:w-32"
                //@ts-ignore
                options={state.options}
                series={state.series}
                type="donut"
                width="360"
              />
            </div>
            <div className="flex-2 md:overflow-x-auto overflow-x-auto  float-right ml-auto mr-4 -mt-4">
              <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
              <TabelDataforissues/>
              </div>
            </div>
          </div>
          <div className="text-center w-fit align-middle m-auto text-blue-400 cursor-pointer pb-2"> See More</div>
        </div>
      </div>
      
    
    </div>
  )
}
